$(document).ready(function() {

    //Edit details
    var $editDetails = $('#edit-details-form');
    $editDetails.validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                required: true,
                uniqueEmail: true,
                email: true
            },
            gender: {
                required: true
            }
        },
        submitHandler: function() {

            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/account/update-details.php',
                data: $editDetails.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title:'',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        if('success' == response.status) {
                            location.reload();
                        }
                    })
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });

    //Edit password
    var $editPassword = $('#edit-password-form');
    $editPassword.validate({
        rules: {
            current_password: {
                required: true
            },
            new_password: {
                required: true
            },
            confirm_password: {
                required: true,
                equalTo: '#new-password'
            }
        },
        submitHandler: function() {

            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/account/update-password.php',
                data: $editPassword.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title: '',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        if('success' == response.status) {
                            location.reload();
                        }
                    })
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });

    //Add address
    var $addAddress = $('#add-address-form');
    $addAddress.validate({
        rules: {
            address_name: {
                required: true,
            },
            address_line_1: {
                required: true
            },
            address_line_2: {
                required: false
            },
            city: {
                required: true
            },
            county: {
                required: false,
            },
            country: {
                required: true,
            },
            postcode: {
                required: true
            },
            type: {
                required: true
            }
        },
        submitHandler: function() {

            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/account/add-address.php',
                data: $addAddress.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title: '',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        location.reload();
                    });
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });

    //Change address type
    $('.js-change-address').on('click', function(event) {
        var $this = $(this);

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/account/change-address-type.php',
            data: {
                address: $this.attr('id'),
                type: $this.val()
            },
            success: function(response) {
                response = JSON.parse(response);
                swal('', response.message, response.status);
            },
            error: function() {
                console.log('Ajax request not received');
            }
        });
    });

    //Edit address - set up validation on form submit
    $(document).on('submit', '.edit-address-form', function(event) {
        event.preventDefault();
        
        var $editAddressForm = $(this);

        // Set up validation if not already set up
        if (!$editAddressForm.data('validator')) {
            $editAddressForm.validate({
                rules: {
                    address_name: {
                        required: true,
                    },
                    address_line_1: {
                        required: true
                    },
                    address_line_2: {
                        required: false
                    },
                    city: {
                        required: true
                    },
                    county: {
                        required: false,
                    },
                    country: {
                        required: true,
                    },
                    postcode: {
                        required: true
                    },
                    type: {
                        required: true
                    }
                }
            });
        }
        
        // Check if form is valid, then submit via AJAX
        if ($editAddressForm.valid()) {
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/account/update-address.php',
                data: $editAddressForm.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title:'',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        location.reload();
                    });
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });
        }
    });

    //Add user (sub-account)
    var $addUser = $('#add-user-form');
    $addUser.validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            first_name: {
                required: true
            },
            last_name: {
                required: true
            }
        },
        submitHandler: function() {
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/account/add-user.php',
                data: $addUser.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title: '',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        if('success' == response.status) {
                            location.reload();
                        }
                    });
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });

    //Edit user - set up validation on form submit
    $(document).on('submit', '.edit-user-form', function(event) {
        event.preventDefault();
        
        var $editUserForm = $(this);

        // Set up validation if not already set up
        if (!$editUserForm.data('validator')) {
            $editUserForm.validate({
                rules: {
                    email: {
                        required: true,
                        email: true
                    },
                    first_name: {
                        required: true
                    },
                    last_name: {
                        required: true
                    }
                }
            });
        }
        
        // Check if form is valid, then submit via AJAX
        if ($editUserForm.valid()) {
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/account/update-user.php',
                data: $editUserForm.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title:'',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        if('success' == response.status) {
                            location.reload();
                        }
                    });
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });
        }
    });

    //Delete user
    $(document).on('click', '.account__delete[data-user-id]', function(event) {
        event.preventDefault();
        
        var $button = $(this);
        var userId = $button.data('user-id');

        if (!userId) {
            swal('', 'Sorry, there was an error deleting the user', 'error');
            return;
        }

        swal({
            title: 'Are you sure?',
            text: 'This will permanently delete this user. They will no longer be able to access the account.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: "#f15a24",
            confirmButtonText: 'Yes, delete it',
            cancelButtonText: 'Cancel',
            closeOnConfirm: false
        }, function(isConfirm) {
            if (isConfirm) {
                $.ajax({
                    type: 'POST',
                    url: $(document.body).data('base') + '/ajax/account/delete-user.php',
                    data: { user_id: userId },
                    success: function(response) {
                        response = JSON.parse(response);

                        swal({
                            title: '',
                            text: response.message,
                            type: response.status,
                            confirmButtonColor: "#f15a24"
                        }, function() {
                            if('success' == response.status) {
                                location.reload();
                            }
                        });
                    },
                    error: function() {
                        console.log('Ajax request not received');
                        swal('', 'Sorry, there was an error deleting the user', 'error');
                    }
                });
            }
        });
    });

    //logout
    $('.logout').click(function(event) {
        event.preventDefault();

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/account/logout.php',
            success: function(response) {
                window.location.href = $(document.body).data('base')
            },
            error: function() {
                console.log('Ajax request not received');
            }
        });
    });

    // Handle hash navigation to open specific tabs
    if(window.location.hash == '#wishlist') {
        // Activate the wishlist tab
        $('.account__tab').removeClass('account__tab--active');
        $('.account__block').removeClass('account__block--active');
        $('.account__tab[data-label="wishlist"]').addClass('account__tab--active');
        $('#wishlist').addClass('account__block--active');
        
        // Save to localStorage
        localStorage.setItem('accountActiveTab', 'wishlist');
        
        // Scroll to top of account section
        $('html, body').animate({
            scrollTop: $('.account').offset().top
        }, 'slow');
    }

    // Order Again - using event delegation for dynamically loaded buttons
    $(document).on('click', '.order-again', function(event) {
        event.preventDefault();

        var order_id = $(this).data('order');

        if(order_id == '' || !order_id) {
            swal('error', 'Sorry, there was a problem re-ordering.', 'error');
            return;
        }

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/account/re-order.php',
            data: 'id='+order_id,
            success: function(response) {
                response = JSON.parse(response);
                if(response.status == 'success') {
                    window.location.href = $(document.body).data('base')+'/cart';
                } else {
                    swal(response.status, response.message, response.status);
                }
            },
            error: function() {
                console.log('Ajax request not received');
                swal('error', 'Sorry, there was a problem re-ordering. Please try again.', 'error');
            }
        });

    });






    $('.account__tab').on('click', function() {
        const label = $(this).data('label');
        if ($(this).hasClass('account__tab--logout')) {
            return;
        }
        $('.account__tab').removeClass('account__tab--active');
        $('.account__block').removeClass('account__block--active');
        $(this).addClass('account__tab--active');
        $('#' + label).addClass('account__block--active');
        
        // Save active tab to localStorage
        localStorage.setItem('accountActiveTab', label);
    });
    
    // Restore active tab on page load (only if no hash is present)
    if (!window.location.hash || window.location.hash !== '#wishlist') {
        const savedTab = localStorage.getItem('accountActiveTab');
        if (savedTab) {
            const $savedTabButton = $('.account__tab[data-label="' + savedTab + '"]');
            if ($savedTabButton.length && !$savedTabButton.hasClass('account__tab--logout')) {
                // Remove active classes from all tabs and blocks
                $('.account__tab').removeClass('account__tab--active');
                $('.account__block').removeClass('account__block--active');
                // Activate saved tab
                $savedTabButton.addClass('account__tab--active');
                $('#' + savedTab).addClass('account__block--active');
            }
        }
    }

    $('.toggle-password').on('click', function (e) {
        e.preventDefault();
        const wrapper = $(this).closest('.form__group');
        const input   = wrapper.find('input');
        const svg1    = $(this).find('.svg-show');
        const svg2    = $(this).find('.svg-hide');

        if (input.attr('type') === 'password') {
            input.attr('type', 'text');
            svg1.hide();
            svg2.show();
        } else {
            input.attr('type', 'password');
            svg2.hide();
            svg1.show();
        }
    });


    $('.account__actions-button').on('click', function (e) {
        e.stopPropagation();

        const parent = $(this).closest('.account__actions');

        $('.account__actions-button--active').not(this).removeClass('account__actions-button--active');
        $('.account__actions-list--active').not(parent.find('.account__actions-list')).removeClass('account__actions-list--active');

        $(this).toggleClass('account__actions-button--active');
        parent.find('.account__actions-list').toggleClass('account__actions-list--active');
    });

    $('.account__actions-list').on('click', function (e) {
        if ($(e.target).closest('[data-open]').length || $(e.target).closest('.order-again').length || $(e.target).closest('.account__preset-add-to-cart').length) {
            return;
        }

        e.stopPropagation();
    });

    $(document).on('click', function () {
        $('.account__actions-button--active').removeClass('account__actions-button--active');
        $('.account__actions-list--active').removeClass('account__actions-list--active');
    });

    $('.account__products-button').on('click', function () {

        let target = $(this).data('cat');
        $('.account__products-button').removeClass('account__products-button--active');
        $('.account__products-block').removeClass('account__products-block--active');

        $(this).addClass('account__products-button--active');

        $('#' + target).addClass('account__products-block--active');
    });


    $(document).on("click", ".order-products__customisation-button", function (e) {
        e.stopPropagation();

        const $wrapper = $(this).closest(".order-products__cell--product");
        const $panel = $wrapper.find(".order-products__customisation");

        $(".order-products__customisation").not($panel)
            .removeClass("order-products__customisation--active");

        $panel.toggleClass("order-products__customisation--active");
    });
    $(document).on("click", ".order-products__customisation", function (e) {
        e.stopPropagation();
    });

    $(document).on("click", function () {
        $(".order-products__customisation--active")
            .removeClass("order-products__customisation--active");
    });

    // Add preset product to cart
    $(document).on("click", ".account__preset-add-to-cart", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var presetId = $link.data("preset-id");

        if (!presetId) {
            swal('error', 'Sorry, there was a problem adding this product to cart.', 'error');
            return;
        }

        // Close the dropdown
        $link.closest('.account__actions').find('.account__actions-button').removeClass('account__actions-button--active');
        $link.closest('.account__actions-list').removeClass('account__actions-list--active');

        // Disable link to prevent double-clicks
        var $linkText = $link.text();
        $link.css('pointer-events', 'none').text('Adding...');

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/account/add-preset-to-cart.php',
            data: { preset_id: presetId },
            success: function(response) {
                response = JSON.parse(response);
                if(response.status == 'success') {
                    // Update cart count if function exists
                    if (typeof updateCartCount === 'function') {
                        updateCartCount();
                    }
                    swal('success', response.message, 'success').then(function() {
                        window.location.href = $(document.body).data('base') + '/cart';
                    });
                } else {
                    swal(response.status, response.message, response.status);
                    $link.css('pointer-events', 'auto').text($linkText);
                }
            },
            error: function() {
                console.log('Ajax request not received');
                swal('error', 'Sorry, there was a problem adding this product to cart. Please try again.', 'error');
                $link.css('pointer-events', 'auto').text($linkText);
            }
        });
    });

    $(document).on("click", ".order-products__image-button", function (e) {
        e.stopPropagation();

        var url   = $(this).data("image-url");
        var $modal = $(".order-products__image-modal");

        $modal.find(".order-products__image-modal-img").attr("src", url);
        $modal.addClass("order-products__image-modal--active");
        $("body").addClass("no-scroll"); // optional if you want to lock scroll
    });

    // Close modal when clicking overlay or close button
    $(document).on("click", ".order-products__image-modal, .order-products__image-modal-close", function () {
        $(".order-products__image-modal").removeClass("order-products__image-modal--active");
        $("body").removeClass("no-scroll");
    });

    // Prevent closing when clicking inside the inner content
    $(document).on("click", ".order-products__image-modal-inner", function (e) {
        e.stopPropagation();
    });



    // View Order (AJAX-loaded modal)
    $('.js-view-order').on('click', function (e) {
        e.preventDefault();

        var orderId = $(this).data('order-id');
        console.log('[View Order] Clicked, id =', orderId);

        if (!orderId) {
            swal('', 'Sorry, we could not find that order.', 'error');
            return;
        }

        // Close the "Actions" dropdown for a cleaner UX
        var $actions = $(this).closest('.account__actions');
        $actions.find('.account__actions-button').removeClass('account__actions-button--active');
        $actions.find('.account__actions-list').removeClass('account__actions-list--active');

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/account/view-order.php',
            data: { order_id: orderId },
            success: function (response) {
                console.log('[View Order] Raw response:', response);

                if (typeof response === 'string') {
                    try {
                        response = JSON.parse(response);
                    } catch (err) {
                        console.error('[View Order] JSON parse failed:', err);
                        swal('', 'Sorry, there was a problem loading that order (invalid response).', 'error');
                        return;
                    }
                }

                if (response.status === 'success' && response.html) {
                    var $modal = $('#view-order-modal');

                    $modal.find('.js-order-modal-content').html(response.html);

                    // Try open with Foundation, fallback to manual show
                    try {
                        if (typeof $modal.foundation === 'function') {
                            $modal.foundation('open');
                        } else if (typeof Foundation !== 'undefined' && Foundation.Reveal) {
                            new Foundation.Reveal($modal).open();
                        } else {
                            $modal.addClass('is-open').show();
                        }
                    } catch (err) {
                        console.error('[View Order] Error opening modal:', err);
                        $modal.addClass('is-open').show();
                    }
                } else {
                    console.warn('[View Order] Error status:', response);
                    swal('', response.message || 'Sorry, there was a problem loading that order.', 'error');
                }
            },
            error: function (xhr) {
                console.error('[View Order] AJAX error:', xhr.status, xhr.responseText);
                swal('', 'Sorry, there was a problem loading that order.', 'error');
            }
        });
    });

    // View Return (AJAX-loaded modal)
    $('.js-view-return').on('click', function (e) {
        e.preventDefault();

        var orderId = $(this).data('order-id');
        console.log('[View Return] Clicked, id =', orderId);

        if (!orderId) {
            swal('', 'Sorry, we could not find that order.', 'error');
            return;
        }

        // Close the "Actions" dropdown for a cleaner UX
        var $actions = $(this).closest('.account__actions');
        $actions.find('.account__actions-button').removeClass('account__actions-button--active');
        $actions.find('.account__actions-list').removeClass('account__actions-list--active');

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/account/view-return.php',
            data: { order_id: orderId },
            success: function (response) {
                console.log('[View Return] Raw response:', response);

                if (typeof response === 'string') {
                    try {
                        response = JSON.parse(response);
                    } catch (err) {
                        console.error('[View Return] JSON parse failed:', err);
                        swal('', 'Sorry, there was a problem loading that return (invalid response).', 'error');
                        return;
                    }
                }

                if (response.status === 'success' && response.html) {
                    var $modal = $('#view-return-modal');

                    $modal.find('.js-return-modal-content').html(response.html);

                    // Initialize returns form handlers for modal content
                    initializeReturnsForm($modal);

                    // Try open with Foundation, fallback to manual show
                    try {
                        if (typeof $modal.foundation === 'function') {
                            $modal.foundation('open');
                        } else if (typeof Foundation !== 'undefined' && Foundation.Reveal) {
                            new Foundation.Reveal($modal).open();
                        } else {
                            $modal.addClass('is-open').show();
                        }
                    } catch (err) {
                        console.error('[View Return] Error opening modal:', err);
                        $modal.addClass('is-open').show();
                    }
                } else {
                    console.warn('[View Return] Error status:', response);
                    swal('', response.message || 'Sorry, there was a problem loading that return.', 'error');
                }
            },
            error: function (xhr) {
                console.error('[View Return] AJAX error:', xhr.status, xhr.responseText);
                swal('', 'Sorry, there was a problem loading that return.', 'error');
            }
        });
    });

    // Initialize returns form handlers (works with both table rows and account__orders-row divs)
    function initializeReturnsForm($container) {
        // Checkbox selection handler
        $container.find("input[type='checkbox'].js-select-line").off('click').on('click', function() {
            var parent = $(this).closest('.account__orders-row, tr');
            var countChecked = $container.find("input[type='checkbox'].js-select-line:checked").length;

            $container.find(".account__return-instructions-title .js-selected-count").html(countChecked);
            
            if($(this).is(":checked")) {
                parent.find(".account__orders-cell, td").not(':first').removeClass('disabled');
                parent.find("textarea").prop('disabled', false);
                parent.find("select").prop('disabled', false);
                parent.find(".account__orders-cell, td").css('pointer-events','all');
            } else {
                parent.find(".account__orders-cell, td").not(':first').addClass('disabled');
                parent.find("textarea").prop('disabled', true);
                parent.find("select").prop('disabled', true);
                parent.find(".account__orders-cell.disabled, td.disabled").css('pointer-events','none');
            }
        });

        // Reason change handler
        $container.find('select.js-reason-change').off('change').on('change', function() {
            var $select = $(this);
            var $reasonWrap = $select.closest('.account__orders-cell, td').find('.return_reason_wrap');
            
            if(this.value == 'Other') {
                $reasonWrap.show();
            } else {
                $reasonWrap.hide();
            }
        });
        
        // Set initial state for reason wrap visibility
        $container.find('select.js-reason-change').each(function() {
            var $select = $(this);
            var $reasonWrap = $select.closest('.account__orders-cell, td').find('.return_reason_wrap');
            
            if(this.value == 'Other') {
                $reasonWrap.show();
            } else {
                $reasonWrap.hide();
            }
        });

        // Form validation and submission
        var $form = $container.find('form[name="returns_form"]');
        if ($form.length) {
            $form.off('submit').validate({
                ignore: [],
                messages: {
                    return_reason: "Please enter a reason for each product being returned."
                },
                focusInvalid: false,
                invalidHandler: function(form, validator) {
                    if (!validator.numberOfInvalids())
                        return;
                    swal({
                        title: '',
                        type: 'error',
                        text: 'Your return could not be submitted. Please double check you have entered all the required fields.',
                        confirmButtonColor: "#f15a24"
                    });
                },
                submitHandler: function() {
                    $container.find('.account__return-instructions').append('<img class="loading" src="' + $(document.body).data('base') + '/images/site/loading.gif">');
                    $.ajax({
                        type: 'POST',
                        url: $(document.body).data('base') + '/ajax/returns/submit-return.php',
                        data: $form.serialize(),
                        success: function(response) {
                            $container.find('.account__return-instructions').find('.loading').remove();
                            response = JSON.parse(response);
                            swal({
                                title:'',
                                text: response.message,
                                type: response.status.toLowerCase(),
                                confirmButtonColor: "#f15a24"
                            }, function() {
                                if(response.status == 'SUCCESS') {
                                    // Close modal and reload page
                                    $('#view-return-modal').foundation('close');
                                    location.reload();
                                }
                            });
                        },
                        error: function() {
                            console.log('Ajax request not received');
                            $container.find('.account__return-instructions').find('.loading').remove();
                        }
                    });
            
                    return false;
                }
            });
        }

        // Initialize dropzones for file uploads
        initializeDropzones($container);
    }

    // Initialize dropzones for dynamically loaded content
    function initializeDropzones($container) {
        // Check if Dropzone is loaded, if not load it dynamically
        if (typeof Dropzone === 'undefined') {
            // Load Dropzone CSS
            if (!$('link[href*="dropzone.min.css"]').length) {
                $('head').append('<link rel="stylesheet" href="https://unpkg.com/dropzone@5/dist/min/dropzone.min.css" type="text/css" />');
            }
            
            // Load Dropzone JS
            var dropzoneScript = document.createElement('script');
            dropzoneScript.src = 'https://unpkg.com/dropzone@5/dist/min/dropzone.min.js';
            dropzoneScript.onload = function() {
                Dropzone.autoDiscover = false;
                initializeDropzonesAfterLoad($container);
            };
            document.head.appendChild(dropzoneScript);
            return;
        }
        
        initializeDropzonesAfterLoad($container);
    }
    
    function initializeDropzonesAfterLoad($container) {
        var ajaxUrl = $(document.body).data('base') + '/ajax/upload-file.php';
        
        $container.find('div.dropzone').each(function() {
            var $dropzone = $(this);
            
            // Destroy existing dropzone instance if it exists
            if ($dropzone[0].dropzone) {
                $dropzone[0].dropzone.destroy();
            }
            
            // Get the dropzone message template from the sibling element
            var $messageTemplate = $dropzone.siblings('.form__dropzone-message');
            var dropzoneMessage = $messageTemplate.length ? $messageTemplate.clone().removeClass('hidden').html() : '';
            
            // Initialize new dropzone instance
            var dropzoneInstance = new Dropzone($dropzone[0], {
                url: ajaxUrl,
                acceptedFiles: ($dropzone.data('types') !== undefined ? $dropzone.data('types') : "image/*,application/pdf"),
                dictDefaultMessage: dropzoneMessage,
                maxFilesize: 8,
                success: function(file, response) {
                    var $response = JSON.parse(response);
                    if ($response.status == 'success') {
                        var previewImg = file.previewElement.querySelector('img');
                        if (previewImg) {
                            previewImg.src = $response.preview;
                        }

                        var file_path = $(document.body).data('base') + $response.file;
                        var line_id = $dropzone.data('line-id');

                        $dropzone.closest('form').append(`
                            <input type="hidden" name="product_line[${line_id}][file][]" value="${file_path}" />
                        `);
                        
                        file.upload.filename = $response.file;
                    } else {
                        swal($response.status, $response.message, $response.status);
                    }
                },
                init: function() {
                    var _this = this;
                    
                    this.on("addedfile", function(file) {
                        $container.find('.blank-placeholder').hide();

                        if ($container.find('.dz-preview').length > 1) {
                            $container.find('.dz-preview:last-of-type').remove();
                        }

                        var removeButton = $("<a class=\"dz-remove btn btn-sm btn-danger\" href=\"javascript:void(0);\"><i class=\"fa fa-times-circle\"></i>&nbsp; Remove</a>");

                        $dropzone.find('.dz-default.dz-message').fadeOut();

                        $dropzone.find('.dz-preview').each(function() {
                            var filename = $('.dz-filename', this);
                            $('.dz-size', this).insertAfter(filename);
                        });

                        removeButton.click(function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            swal({
                                title: 'Confirm Delete',
                                text: 'Are you sure you want to remove this file?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: "#629637",
                                confirmButtonText: "OK",
                                closeOnConfirm: true
                            }, function(isConfirm) {
                                if (isConfirm) {
                                    file.previewElement.parentNode.removeChild(file.previewElement);
                                    _this.removeFile(file);
                                    $dropzone.closest('form').find('input[name*="[file][]"][value*="' + file.upload.filename + '"]').remove();
                                    $dropzone.find('.dz-default.dz-message').fadeIn();
                                }
                            });
                        });

                        file.previewElement.appendChild(removeButton[0]);
                    });
                }
            });
        });
    }
});